import { OvertimeStatus } from '../../../../../globalTypes';

export function getTextColorByOvertimeStatus(status: OvertimeStatus): 'success' | 'muted' {
  switch (status) {
    case OvertimeStatus.Signed:
    case OvertimeStatus.ManuallySigned:
    case OvertimeStatus.Archived:
      return 'success';
    default:
      return 'muted';
  }
}
